<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
    {{message}}
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">Oui</button>
    <button mat-button [mat-dialog-close]="false">Non</button>
</div>
